import type { Proveedor } from '../services/proveedorService';

/**
 * Convierte `CondVta` del proveedor al valor del Select de forma de pago en FC/NC compra.
 * Tolera `CondVta`/`condVta`, espacios y diferencias de puntos (p. ej. "CTA. CTE" vs "CTA.CTE.").
 */
export function formaDePagoDesdeCondVtaProveedor(
  formas: readonly string[],
  proveedor: Proveedor,
  fallback: string
): string {
  const ext = proveedor as Proveedor & Record<string, unknown>;
  const raw = String(ext.condVta ?? ext['CondVta'] ?? '').trim();
  if (!raw) return fallback;

  const norm = (s: string) => s.replace(/[\s.]/g, '').toUpperCase();
  const k = norm(raw);
  const byNorm = formas.find((fp) => norm(fp) === k);
  if (byNorm) return byNorm;

  return formas.find((fp) => fp.toUpperCase() === raw.toUpperCase()) ?? fallback;
}
